export default __webpack_public_path__ + "static/media/preloading-img.7a1d8a08.svg";